import React from 'react';
import { Query } from 'react-apollo';
import CalculatorIFrame from './CalculatorIFrame';
import LoadingIndicator from '../../components/common/LoadingIndicator';
import { GET_NEW_OFFER_URL } from './queries';

function NewOffer() {
  return (
    <Query query={GET_NEW_OFFER_URL}>
      {({ loading, error, data }) => {
        if (loading) return <LoadingIndicator />;
        if (error || !data || !data.currentPartner) return null;

        return <CalculatorIFrame url={data.currentPartner.offerCalculatorApiUrl} />;
      }}
    </Query>
  );
}

export default NewOffer;
